import React from 'react';

import { IconButton } from '@mui/material';
import type { IconButtonProps } from '@mui/material';
import { Plus } from 'lucide-react';

import { AlineTooltip } from './AlineTooltip';

interface PrimaryPlusIconButtonProps extends Omit<
  IconButtonProps,
  'children' | 'color' | 'size' | 'sx'
> {
  tooltip: string;
}

export const PrimaryPlusIconButton = React.forwardRef<
  HTMLButtonElement,
  PrimaryPlusIconButtonProps
>(function PrimaryPlusIconButton(props, ref) {
  const { tooltip, ...buttonProps } = props;

  return (
    <AlineTooltip arrow placement="top" title={tooltip}>
      <IconButton
        ref={ref}
        aria-label={buttonProps['aria-label'] ?? tooltip}
        size="small"
        sx={{
          '&:active, &:hover, &.Mui-focusVisible': {
            color: 'common.white',
          },
          '&:hover': { backgroundColor: 'primary.dark' },
          backgroundColor: 'primary.main',
          color: 'common.white',
          height: 32,
          width: 32,
        }}
        {...buttonProps}
      >
        <Plus size={18} strokeWidth={2.5} />
      </IconButton>
    </AlineTooltip>
  );
});
